interface IFormatFieldOptions<T extends string | number = string> {
  fieldName: string;
  invalidValues?: (T | null | undefined)[];
  specialCases?: Partial<Record<T, string | number>>;
}

export const autoCompleteFormatField = <T extends string | number>(
  value: T | null | undefined,
  {
    fieldName,
    invalidValues = ['0'] as (T | null | undefined)[],
    specialCases = {} as Partial<Record<T, string | number>>,
  }: IFormatFieldOptions<T>
): Record<string, string | number> => {
  if (invalidValues.includes(value)) return {};

  return {
    [fieldName]: Object.prototype.hasOwnProperty.call(specialCases, value)
      ? specialCases[value]
      : value
  };
};
